export async function getAllClients(token) {
    const url = `api/client`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}
export async function getServiceRequests(token) {
    const url = `api/client/service-requests`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}

export async function getClientServiceRequestsDetailsByClientIDAndServiceRequestID(clientId, serviceRequestId, token) {
    const url = `api/client/service-requests-by-clientID-and-serviceRequestId?clientId=${encodeURIComponent(clientId)}&serviceRequestId=${encodeURIComponent(serviceRequestId)}`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}

export async function getClientServiceRequestsDetailsByClientID(clientId, token) {
    const url = `api/client/service-requests-by-clientID?clientId=${encodeURIComponent(clientId)}`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}

export async function getCompanyLogoByCompanyId(companyId) {
    const url = `api/public/company-logo-companyId?companyId=${encodeURIComponent(companyId)}`;

    const response = await fetch(url,{
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch company logo: ${response.status}`);
    }
    return await response.json();
}

export async function getClientById(clientId, token){
    const url = `api/client/${encodeURIComponent((clientId))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}

export async function getClientByClientIdentity(clientId, token){
    const url = `api/client/by-clientIdentity/${encodeURIComponent((clientId))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All clients: ${response.status}`);
    }
    return await response.json();
}

export async function getClientByClient_Identity(token){
    const url = `api/client/client_identity`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch client by identity`);
    }
    return await response.json();
}

export async function deleteClientById(clientId, token){
    const url = `api/client/${encodeURIComponent((clientId))}`;

    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to delete client: ${response.status}`);
    }
}

export async function editClient(clientId, data, token){
    const url = `api/client/${encodeURIComponent((clientId))}`;

    const response = await fetch(url, {
        method: "PUT",
        body: data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to delete client: ${response.status}`);
    }
}
